import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Modal, OverlayTrigger, Tooltip, Panel, Accordion, Well, PanelGroup} from 'react-bootstrap'
import phonez from '../../core/phonez'
import extract from '../../core/extract'
import Selector from '../../core/components/Selector'
import Icon from '../../core/components/Icon'
import {queryActivityRef, queryOpeningTicketPurposeRef} from '../../reference/actions'
import {queryContactSuggest} from '../actions'
import moment from 'moment'
import i18n from '../i18n'
import UpdateInterventionPeriodPanel from './UpdateInterventionPeriodPanel'
import style from './ContactSuggestSelector.less'

function linkedWithIconName(contact) {
    if (contact.foundViaInterventionZone) return 'location'

    switch(contact.directlyLinkedWith) {
        case 'LinkedToPatrimony': return 'individualHouse'
        case 'LinkedToContract': return 'insurance'
        case 'LinkedToAgency': return 'agency'
        case 'LinkedToCompany': return 'patrimony'
    }
}

function linkedWithInfo(contact) {
    if (contact.foundViaInterventionZone) return i18n.foundViaInterventionZone
    return extract(i18n.linkedWithInfo, contact.directlyLinkedWith)
}

function linkedWithStatus(contact) {
    if (contact.directlyLinkedWith === 'LinkedToPatrimony' || contact.directlyLinkedWith === 'LinkedToContract') return 'primary'
}

function enrichActivities(activities, {openingTicketPurposes}, activitiesReference, incidentType) {
    let matchPurpose = openingTicketPurposes.find(o => o.uid === incidentType)
    const matchesActivities = matchPurpose && matchPurpose.activities
    return activities.map(activity => {
        const activityReference = activitiesReference.find(o => o.uid === activity || o.uid === activity.activityUid)
        const doesMatch = Boolean(activityReference && matchesActivities && matchesActivities.find(matchActivity => matchActivity.uid === activityReference.uid))
        return activityReference ? {...activityReference, doesMatch} : undefined
    }).filter(Boolean)
    .sort((a, b) => {
        return a.doesMatch ? -1 : b.doesMatch ? 1 : 0
    })

}

function _displayActivitiesOfContract(activities) {
    return (<small> {activities.map(({doesMatch, label}, index) => (
        <span key={index}>{index > 0 ? ' - ' : ''}{doesMatch ? (<b>{label}</b>) : label}</span>
    ))}</small>)
}

class ContactSuggestSelector extends Component {
    static propTypes = {
        company: PropTypes.object.isRequired,
        patrimony: PropTypes.object.isRequired,
        incidentType: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, company, patrimony, incidentType} = this.props
        dispatch(queryContactSuggest({patrimonyUid: patrimony.uid, incidentTypeUid: incidentType}))
        dispatch(queryActivityRef())
        dispatch(queryOpeningTicketPurposeRef(company.uid))
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.patrimony != nextProps.patrimony
            || this.props.incidentType != nextProps.incidentType) {
            const {dispatch, patrimony, incidentType} = nextProps

            dispatch(queryContactSuggest({patrimonyUid: patrimony.uid, incidentTypeUid: incidentType}))
        }

        if (this.props.company != nextProps.company) {
            const {dispatch, company} = nextProps

            dispatch(queryOpeningTicketPurposeRef(company.uid))
        }
    }

    _openPanel(key) {
        const {activeKey} = this.state

        const nextActiveKey = activeKey != key && key || null
        this.setState({activeKey: nextActiveKey})
    }

    _openContract(key) {
        const {activeKeyContract} = this.state

        const nextActiveKey = activeKeyContract !== key && key || null
        this.setState({activeKeyContract: nextActiveKey})
    }

    _openModal(event, activeContact) {
        event.preventDefault()
        event.stopPropagation()

        const referenceInterventionPeriod = activeContact.interventionPeriods.find((ip) => ip.reference)
        const activeKey = referenceInterventionPeriod && referenceInterventionPeriod.uid
        const activeKeyContract = activeContact.contracts && activeContact.contracts.length > 0 && activeContact.contracts[0].uid
        this.setState({modalOpened: true, activeContact, activeKey, activeKeyContract})
    }

    _closeModal() {
        this.setState({modalOpened: false, activeContact: null, activeKey: null, activeKeyContract: null})
    }

    render() {
        const {activityReference, openingTicketPurposeReference, suggest, patrimony, incidentType, ...others} = this.props
        const {modalOpened, activeContact} = this.state

        const tooltip = (text, status) => {
            return (
                <Tooltip className={status && 'tooltip-' + status}>
                    {text}
                </Tooltip>
            )
        }

        const displayContact = (contact) => (
            <div className={style.contact}>
                <OverlayTrigger
                    placement='bottom'
                    overlay={tooltip(linkedWithInfo(contact), linkedWithStatus(contact))}>
                    <Icon icon={linkedWithIconName(contact)} size='xs' />
                </OverlayTrigger>
                <div className={style.container}>
                    <p>{contact.name.firstName} {contact.name.lastName} {contact.name.value}</p>
                    <p>{_displayActivitiesOfContract(enrichActivities(contact.activities, openingTicketPurposeReference, activityReference, incidentType))}</p>
                </div>
                <a
                    href=''
                    onClick={(e) => this._openModal(e, contact)}>
                    {i18n.showMore}
                </a>
            </div>
        )

        return (
            <div>
                <Selector
                    source={suggest}
                    identify={(c) => c.uid}
                    display={displayContact}
                    {...others} />
                {activeContact && (
                    <Modal
                        show={modalOpened}
                        onHide={() => this._closeModal()}>
                        <Modal.Header>
                            <Modal.Title>{activeContact.name.firstName} {activeContact.name.lastName} {activeContact.name.value}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <ul className={style.data}>
                                {activeContact.phones.length > 0 && (
                                    <li>
                                        <label>> {i18n.phone} :</label>
                                        {activeContact.phones.map((phone, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(phone).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {activeContact.emails.length > 0 && (
                                    <li>
                                        <label>> {i18n.email} :</label>
                                        {activeContact.emails.map((email, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {email}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {activeContact.fax.length > 0 && (
                                    <li>
                                        <label>> {i18n.fax} :</label>
                                        {activeContact.fax.map((fax, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(fax).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}

                                {activeContact.contracts.length > 0 && (
                                    <Well bsSize={"small"}>
                                        <h4>Les contrats</h4>
                                        <PanelGroup accordion={true} onSelect={(k) => this._openContract(k)}>
                                            {activeContact.contracts.map(c => {
                                                    return (<Panel header={(<h5>{c.label}</h5>)} key={c.uid} eventKey={c.uid}>
                                                    <ul className={style.data}>
                                                        {c.contractNumber && <li><label>> N° de contrat :</label> <span>{c.contractNumber}</span></li>}
                                                        {c.contractor && <li><label>> Contractant :</label> <span>{(c.contractor.patrimony && '(Patrimoine) ' + c.contractor.patrimony.name) || c.contractor.contractorType}</span></li>}
                                                        {c.validityPeriod && <li><label>> Période de validité :</label> <span>{moment(c.validityPeriod.startDate).format(i18n.dateFormat.fromLonger)} {moment(c.validityPeriod.endDate).format(i18n.dateFormat.toLonger)}</span></li>}
                                                        {c.phoneNumbers && <li><label>> Contacts :</label> <span>{c.phoneNumbers.join(', ')}</span></li>}
                                                        {c.instructions && <li><label>> Instructions :</label> <span>{c.instructions}</span></li>}
                                                        {c.commentaries && <li><label>> Commentaire :</label> <span>{c.commentaries}</span></li>}
                                                        {c.activities.length > 0 && <li><label>> Activities : </label>
                                                            {_displayActivitiesOfContract(enrichActivities(c.activities, openingTicketPurposeReference, activityReference, incidentType))}
                                                        </li>}
                                                        {Object.keys(c.additionalInfos).length > 0 &&
                                                            (<li><label>> Informations complémentaire :</label>
                                                                <ul>
                                                                {Object.entries(c.additionalInfos).map(([key, value]) => {
                                                                return (<li><label> {key} : </label> {value}</li>)
                                                                })}
                                                                </ul>
                                                            </li>)
                                                        }
                                                    </ul>
                                                    {c.commitments && c.commitments.length > 0 && c.commitments.map((interventionPeriod) => (
                                                        <Accordion>
                                                            <UpdateInterventionPeriodPanel
                                                                key={interventionPeriod.uid}
                                                                eventKey={interventionPeriod.uid}
                                                                interventionPeriod={interventionPeriod}
                                                                incidentType={incidentType}
                                                                openingTicketPurposeReference={openingTicketPurposeReference}
                                                                patrimony={patrimony} />
                                                        </Accordion>
                                                    ))}
                                                </Panel>)
                                            })}
                                        </PanelGroup>
                                    </Well>
                                )}
                            </ul>

                            {activeContact.interventionPeriods.length > 0 && (
                                <Well bsSize={"small"}>
                                    <h4> Périodes d'interventions</h4>
                                    <Accordion
                                        // activeKey={activeKey} utiliser pour expand le panel de la période de référence
                                        onSelect={(k) => this._openPanel(k)}>
                                        {activeContact.interventionPeriods.map((interventionPeriod) => (
                                            <UpdateInterventionPeriodPanel
                                                key={interventionPeriod.uid}
                                                eventKey={interventionPeriod.uid}
                                                interventionPeriod={interventionPeriod}
                                                incidentType={incidentType}
                                                openingTicketPurposeReference={openingTicketPurposeReference}
                                                patrimony={patrimony} />
                                        ))}
                                    </Accordion>
                                </Well>
                            )}

                            <ButtonToolbar>
                                <Button
                                    bsSize='large'
                                    onClick={() => this._closeModal()}>
                                    {i18n.close}
                                </Button>
                            </ButtonToolbar>
                        </Modal.Body>
                    </Modal>
                )}
            </div>
        )
    }
}

ContactSuggestSelector = connect((state) => ({
    activityReference: state.reference.activityRef,
    openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
    suggest: state.provider.contact.suggest
}))(ContactSuggestSelector)

export default ContactSuggestSelector


// WEBPACK FOOTER //
// ./lib/provider/components/ContactSuggestSelector.js